import styled from 'styled-components';
import { tvar } from '@versita/frontend/design-tokens';

export const StyledAutoCompleteWrapper = styled.div`
  position: relative;
  &:not(:last-child) {
    margin-bottom: ${tvar('space.x2')};
  }
`;

export const StyledAutoComplete = styled.ul`
  position: absolute;
  list-style: none;
  top: calc(100% + ${tvar('space.half')});
  left: 0;
  background: ${tvar('colors.fill.primary')};
  overflow-y: auto;
  max-height: 30rem;
  border: 1px solid ${tvar('colors.neutrals.grey2')};
  width: 100%;
  z-index: 1;

  li button:focus {
    outline: 1px solid;
    outline-offset: -1px;
  }
`;

export const StyledAutoCompleteItem = styled.button`
  background: transparent;
  border: none;
  width: 100%;
  text-align: left;
  padding: ${tvar('space.x1')};
  border-bottom: 1px solid ${tvar('colors.neutrals.grey2')};
  font-size: ${tvar('typographies.small.fontSize')};
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
  display: flex;

  span:nth-child(2) {
    margin-left: auto;
    color: ${tvar('colors.typography.subtle')};
    text-align: right;
  }

  &:hover {
    background-color: ${tvar('colors.neutrals.grey1')};
  }
`;
